<template>
  <form @submit.prevent="handleSubmit">
    <div id="content-to-pdf" class="pdf-container web-container-mode" ref="promissoryNoteContent">
      <div class="page">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <p style="margin: auto; text-align: center;">
                <span>
                  <table border="0" cellspacing="0" cellpadding="0" style="margin: 0 auto;">
                    <tr>
                      <td>
                        <img width="137" height="70" src="/img/LOGOTIPOGOLDERGFUND.jpg" />
                      </td>
                    </tr>
                  </table>
                </span>
              </p>
            </div>
            <div class="col-12">
              <div class="form-group row" style="display: flex; justify-content: right;">
                <label for="numContract" class="col-form-label label-form" style="margin-right: 0px;">Número:</label>
                <select id="promissoryNoteNumberSelect" v-model="store.selectedAmortizationIndex"
                  class="form-select selectpicker border-dark promissory-note-select"
                  style="border-bottom: 1px solid #F00; color: #F00;" data-live-search="true"
                  :disabled="!store.form?.quotations?.loanAmortizations?.length" title="#"
                  @change="onAmortizationChange" required>
                  <option value="" disabled># de pagaré</option>
                  <option v-for="(loanAmortization, index) in store.form?.quotations?.loanAmortizations || []"
                    :key="loanAmortization.id" :value="index" :disabled="index === 0">
                    <!-- Esta línea deshabilita el index 0 -->
                    {{ index }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-12">
              <h1 style="padding-left: 393pt;text-indent: -14pt;text-align: right; font-size: 16px !important;">
                Anexo C.
              </h1>
            </div>
          </div>
          <div class="row">
            <p class="s1"
              style="padding-top: 9pt;padding-bottom: 9pt;text-indent: 0pt;text-align: center;margin: auto;font-size: 16px !important;">
              PAGARÉ
            </p>
            <p style="padding-top: 2pt;text-indent: 0pt;text-align: left;"><br /></p>
          </div>
          <div class="row">
            <p style="padding-left: 5pt;text-indent: 0pt;text-align: justify;">
              El (La) que suscribe C. <span class="style-set-data">{{ nameAccredited }}</span> <b>DEBO Y PAGARÉ
              </b>incondicionalmente, a la orden de
              <b>KVF GROUP, S.A. DE C.V.</b>, la cantidad de <span class="style-set-data">{{ amount }}</span><span
                style=" color: #FF0000;"> ({{ amountWord }} 00/100 M.N.), </span>
              importe que recibo a mi entera satisfacción y que me comprometo a pagar precisamente el día
              <input type="number" class="form-control underline-input inline-input"
                :style="getInputStyle(day, 'number')" v-model="day" disabled /> del mes de <input type="text"
                class="form-control underline-input inline-input" :style="getInputStyle(monthName)" v-model="monthName"
                disabled /> del año
              <input type="number" class="form-control underline-input inline-input"
                :style="getInputStyle(year, 'number')" v-model="year" disabled />, en la ciudad de Cancún, Municipio de
              Benito
              Juárez, Estado de Quintana Roo.
            </p>
            <p style="text-indent: 0pt;text-align: left;"><br /></p>
            <p style="padding-left: 5pt;text-indent: 0pt;text-align: justify;">
              Este PAGARÉ formará parte de una serie enumeradas del
              <span style="color: #FF0000;">1 al</span> <span class="style-set-data"> {{ totalTerm }} </span> y que
              estarán sujetos a la condición de que,
              al no pagarse cualquiera de ellos a su vencimiento, serán exigibles todos los que le sigan en número,
              además
              de los ya vencidos, desde la fecha de vencimiento de este documento hasta el día de su liquidación.
            </p>
            <p style="text-indent: 0pt;text-align: left;"><br /></p>
            <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: justify;">
              El importe principal de este PAGARÉ causará un interés ordinario a razón de la tasa del <span
                class="style-set-data">{{ referenceRate }}</span> <span style="color: #FF0000;">({{ referenceRateWord }}
                por
                ciento) anual </span>
              <span style="color: #000;">desde su fecha de suscripción y hasta su total y completo pago.</span>
            </p>
            <p style="text-indent: 0pt;text-align: left;"><br /></p>
            <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: justify;">
              En caso de falta de pago de la cantidad suscrita en este PAGARÉ, causará un interés moratorio a razón de
              la
              tasa del <span class="style-set-data">{{ penaltyRate }}</span> <span style="color: #FF0000;">({{
                penaltyRateWord }} por ciento) diario </span>
              <span style="color: #000;">sobre el importe vencido y no pagado, desde el día siguiente de su vencimiento
                y hasta la fecha en que la cantidad principal sea totalmente pagada.</span>
            </p>
            <p style="text-indent: 0pt;text-align: left;"><br /></p>
            <p style="padding-left: 5pt;text-indent: 0pt;text-align: justify;">
              El Suscriptor pagará la suma principal, los intereses pactados, y cualquier otra cantidad establecida en
              el
              presente PAGARÉ, sin que para ello exista necesidad de requerimiento previo, incluyendo en este sentido,
              su
              renuncia expresa a cualquier diligencia, protesto, presentación, aviso de falta de pago o cualquier otra
              notificación en relación con el cumplimiento de este pagaré.
            </p>
            <p style="text-indent: 0pt;text-align: left;"><br /></p>
            <p style="padding-left: 5pt;text-indent: 0pt;text-align: justify;">
              La omisión del tenedor del presente PAGARÉ en el ejercicio de cualquiera de sus derechos, en ningún caso
              constituirá la renuncia de los derechos y obligaciones pactados en el mismo.
            </p>
            <p style="text-indent: 0pt;text-align: left;"><br /></p>
            <p style="padding-left: 5pt;text-indent: 0pt;text-align: justify;">
              El suscriptor acepta, expresa e incondicionalmente, que el PAGARÉ se regirá por las leyes aplicables de
              los
              Estados Unidos Mexicanos. Asimismo, el suscriptor acepta y se somete desde ahora, expresa e
              incondicionalmente, a la jurisdicción de los Tribunales competentes de la ciudad de Cancún, Municipio de
              Benito Juárez, Estado de Quintana Roo, para todo lo relativo al cumplimiento y/o ejecución de este PAGARÉ,
              reconociendo la competencia de los mismos, y renuncia en forma expresa e irrevocable a cualquier otra
              jurisdicción presente o futura que le pudiera corresponder por la razón que fuese.
            </p>
            <p style="padding-top: 1pt;text-indent: 0pt;text-align: left;"><br /></p>
            <h2 style="padding-left: 5pt;text-indent: 0pt;text-align: justify;">
              Este PAGARÉ se suscribe en la ciudad de Cancún, Municipio de Benito Juárez, Estado de Quintana Roo con
              fecha <input type="date" class="form-control underline-input inline-date-input"
                style="border-bottom-color: #FF0000;" v-model="subscriptionDate" />.
            </h2>
            <p style="padding-top: 2pt;text-indent: 0pt;text-align: left;"><br /></p>
            <table style="border-collapse:collapse;margin-left:8.004pt" cellspacing="0">
              <tr style="height:108pt">
                <td style="width:250pt">
                  <p class="s7"
                    style="padding-top: 10px; padding-left: 41pt;padding-right: 31pt;text-indent: 0pt;line-height: 10pt;text-align: center;">
                    <strong>EL SUSCRIPTOR</strong>
                  </p>
                  <p class="s8" style="padding-left: 2pt;text-indent: 0pt;line-height: 12pt;text-align: left;">
                    Nombre: <span>{{ nameAccredited }}</span>
                  </p>
                  <p class="s8" style="padding-left: 2pt;text-indent: 0pt;line-height: 12pt;text-align: left;">
                    Domicilio: <span>{{ addressAccredited }}</span>
                  </p>
                  <p class="s8" style="padding-left: 2pt;text-indent: 0pt;text-align: left;">
                    Teléfono: {{ phoneAccredited }}
                  </p>
                  <p style="text-indent: 0pt;text-align: left;"><br /></p>
                  <p style="text-indent: 0pt;text-align: left;"><br /></p>
                  <p style="text-indent: 0pt;text-align: left;"><br /></p>
                  <p style="padding-left: 27pt;text-indent: 0pt;line-height: 1pt;text-align: left;"></p>
                  <p class="s8"
                    style="margin-right: 24px; margin-left: 24px; padding-top: 20pt; padding-left: 41pt;text-indent: 0pt;line-height: 11pt;text-align: center;border-bottom: 1px solid black;">
                  </p>
                  <p class="s8"
                    style="padding-top: 2px;padding-left: 41pt;padding-right: 31pt;text-indent: 0pt;line-height: 11pt;text-align: center;">
                    FIRMA
                  </p>
                </td>
                <td style="width:250pt">
                  <p class="s7"
                    style="padding-top: 10px;padding-left: 41pt;text-indent: 0pt;line-height: 10pt;text-align: center;">
                    <strong>EL AVAL</strong>
                  </p>
                  <p class="s8" style="padding-left: 18pt;text-indent: 0pt;line-height: 12pt;text-align: left;">
                    Nombre: <input type="text" class="form-control underline-input inline-input"
                      :style="getInputStyle(guarantorName)" v-model="guarantorName" required />
                  </p>
                  <p class="s8" style="padding-left: 18pt;text-indent: 0pt;line-height: 12pt;text-align: left;">
                    Domicilio: <input type="text" class="form-control underline-input inline-input"
                      :style="getInputStyle(guarantorAddress)" v-model="guarantorAddress" required />
                  </p>
                  <p class="s8" style="padding-left: 18pt;text-indent: 0pt;text-align: left;">
                    Teléfono: <input type="text" class="form-control underline-input inline-input"
                      :style="getInputStyle(guarantorPhone)" v-model="guarantorPhone" required />
                  </p>
                  <p style="text-indent: 0pt;text-align: left;"><br /></p>
                  <p style="text-indent: 0pt;text-align: left;"><br /></p>
                  <p style="text-indent: 0pt;text-align: left;"><br /></p>
                  <p style="padding-left: 43pt;text-indent: 0pt;line-height: 1pt;text-align: left;"></p>
                  <p class="s8"
                    style="margin-right: 4px; margin-left: 48px; padding-top: 20pt; padding-left: 41pt;text-indent: 0pt;line-height: 11pt;text-align: center;border-bottom: 1px solid black;">
                  </p>
                  <p class="s8"
                    style="padding-top: 2px; padding-left: 41pt;text-indent: 0pt;line-height: 11pt;text-align: center;">
                    FIRMA
                  </p>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="form-actions">
      <button class="download-btn">Descargar PDF</button>
    </div>
  </form>
</template>

<script setup>
import { ref, onMounted, computed, getCurrentInstance, watch, nextTick } from 'vue';
import { usePromissoryNoteStore } from '@/pinia/LoanApplications/Legal/usePromissoryNoteStore.module';

const store = usePromissoryNoteStore();
const promissoryNoteContent = ref(null);

// Acceder a la instancia de la app
const app = getCurrentInstance();
const filters = app?.appContext.config.globalProperties.$filters;

const nameAccredited = computed({
  get: () => {
    if (store.form.prospects?.generalInformation.businessName === null) {
      return `${store.form.prospects?.generalInformation?.firstName || ''} ${store.form.prospects?.generalInformation?.lastName || ''} ${store.form.prospects?.generalInformation?.mothersMaidenName || ''}`;
    } else {
      return store.form.prospects?.generalInformation?.businessName || '';
    }
  }
});

const addressAccredited = computed({
  get: () => {
    return `${store.form?.prospects?.addressAccredited?.street || ''} ${store.form?.prospects?.addressAccredited?.exteriorNumber || ''} ${store.form?.prospects?.addressAccredited?.interiorNumber || ''} ${store.form?.prospects?.addressAccredited?.district || ''}`;
  }
});

const phoneAccredited = computed({
  get: () => {
    return `${store.form?.prospects?.generalInformation?.cellPhone || ''} ${store.form?.prospects?.generalInformation?.homePhone || ''} ${store.form?.prospects?.generalInformation?.officePhone || ''}`;
  }
});

/**#region de configuración del combo de selector de número de pagare */
const onAmortizationChange = () => {
  store.setSelectedAmortization(store.selectedAmortizationIndex);
};

watch(
  () => store.selectedApplication,
  (newIndex) => {
    nextTick(() => {
      if (newIndex !== null) {
        const selectNum = $("#promissoryNoteNumberSelect");
        if (selectNum.length) {
          if (newIndex.quotations?.loanAmortizations?.length !== 0) {
            // Seleccionar el primer pagaré por defecto
            const numPromissorySelected = store.isEdit === true ? store.form?.promissoryNotes?.promissoryNumber : 1;
            store.setSelectedAmortization(numPromissorySelected);
          }

          // Inicializar el selectpicker después de actualizar los datos
          nextTick(() => {
            if (selectNum.length) {
              selectNum.selectpicker('refresh');
              if (!store.selectedApplication) {
                select.selectpicker('val', '');
              }
            }
          });
        }
      }
    });
  },
  { immediate: true }
);

/**Limpia la modal cuando brinca el flujo de edición a generación */
watch(
  () => store.selectedAmortizationIndex,
  (newIndex) => {
    nextTick(() => {
      const selectNum = $("#promissoryNoteNumberSelect");
      if (selectNum.length) {
        selectNum.selectpicker('refresh');
        selectNum.selectpicker('val', newIndex === null ? '' : newIndex);
      }
    });
  },
  { immediate: true }
);

// Agrega esto al onMounted o crea uno si no existe
onMounted(() => {
  nextTick(() => {
    const selectNum = $("#promissoryNoteNumberSelect");
    if (selectNum.length) {
      selectNum.selectpicker('refresh');

      // Fuerza el ancho del contenedor principal 80px sugerido
      const container = selectNum.closest('.bootstrap-select');
      if (container) {
        container.css({
          'width': '55px',
          'min-width': '55px',
          'max-width': '55px'
        });
      }
      selectNum.next('.dropdown-toggle').css('width', '55px');

      // Establece el valor seleccionado basado en el store
      if (store.selectedAmortizationIndex !== null) {
        selectNum.selectpicker('val', store.selectedAmortizationIndex);
      } else {
        selectNum.selectpicker('val', '');
      }
    }
  });
});


// Agrega este watcher
watch(
  () => store.form?.quotations?.loanAmortizations,
  (newAmortizations) => {
    if (newAmortizations?.length) {
      nextTick(() => {
        $("#promissoryNoteNumberSelect").selectpicker('refresh');
      });
    }
  },
  { deep: true }
);
/**#endregion de configuración del combo de selector de número de pagare */

const amount = computed({
  get: () => filters?.formatNumber(store.form?.quotations?.paymentPeriodAmount),
  set: (value) => {
    if (store.form?.quotations) {
      store.form.quotations.paymentPeriodAmount = filters?.formatNumber(value);
    }
  }
});

const amountWord = computed(() => {
  const monto = store.form?.quotations?.paymentPeriodAmount;
  if (monto === undefined || monto === null) return '';

  const numero = Number(monto);
  if (isNaN(numero)) return '';

  // Capitaliza la primera letra (ej: "veinticinco..." → "Veinticinco...")
  const letras = filters?.numeroALetras(numero);
  return letras.charAt(0).toUpperCase() + letras.slice(1);
});

const referenceRate = computed({
  get: () => filters?.formatPercent(store.form?.quotations?.annualRateWithVat),
  set: (value) => {
    if (store.form?.quotations) {
      store.form.quotations.annualRateWithVat = filters?.formatPercent(value);
    }
  }
});

const referenceRateWord = computed(() => {
  const rate = store.form?.quotations?.annualRateWithVat;
  return rate ? filters?.porcentajeALetras(filters?.formatPercent(rate)) : '';
});

const penaltyRate = computed({
  get: () => filters?.formatPercent(store.form?.quotations?.periodRateWithVat),
  set: (value) => {
    if (store.form?.quotations) {
      store.form.quotations.periodRateWithVat = filters?.formatPercent(value);
    }
  }
});

const penaltyRateWord = computed(() => {
  const periodRate = store.form?.quotations?.periodRateWithVat;
  return periodRate ? filters?.porcentajeALetras(filters?.formatPercent(periodRate)) : '';
});

const subscriptionDate = computed({
  get: () => filters?.formatDateForInput(store.form?.promissoryNotes?.subscriptionDate),
  set: (value) => {
    if (store.form && store.form.promissoryNotes) {
      store.form.promissoryNotes.subscriptionDate = filters?.formatDateForInput(value);
    }
  }
});

const guarantorName = computed({
  get: () => store.form?.promissoryNotes?.guarantorName,
  set: (value) => {
    if (store.form && store.form.promissoryNotes) {
      store.form.promissoryNotes.guarantorName = value;
    }
  }
});

const guarantorAddress = computed({
  get: () => store.form?.promissoryNotes?.guarantorAddress,
  set: (value) => {
    if (store.form && store.form.promissoryNotes) {
      store.form.promissoryNotes.guarantorAddress = value;
    }
  }
});

const guarantorPhone = computed({
  get: () => store.form?.promissoryNotes?.guarantorPhone,
  set: (value) => {
    if (store.form && store.form.promissoryNotes) {
      store.form.promissoryNotes.guarantorPhone = value;
    }
  }
});

/**Fecha de disposición */
// Obtener la fecha actual desde el store (o null si no existe)
const getCurrentDate = () => {
  const dateStr = store.form?.quotations?.disbursementDate;
  return dateStr ? new Date(dateStr) : null;
};

// Actualizar el valor de disbursementDate en el store
const updateDisbursementDate = (newDate) => {
  if (store.form?.quotations) {
    store.form.quotations.disbursementDate = newDate.toISOString();
  }
};

// Año (getter + setter)
const year = computed({
  get: () => getCurrentDate()?.getFullYear() || '',
  set: (newYear) => {
    const currentDate = getCurrentDate() || new Date(); // Si no hay fecha, usa la actual
    currentDate.setFullYear(Number(newYear));
    updateDisbursementDate(currentDate);
  },
});

const monthName = computed(() => {
  const monthNumber = month.value; // Obtiene el valor numérico de `month`
  if (!monthNumber || monthNumber < 1 || monthNumber > 12) return '';

  const months = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];
  return months[monthNumber - 1]; // Restamos 1 porque el array empieza en 0
});

// Mes (getter + setter, 1-12)
const month = computed({
  get: () => (getCurrentDate() ? getCurrentDate().getMonth() + 1 : ''),
  set: (newMonth) => {
    const currentDate = getCurrentDate() || new Date();
    currentDate.setMonth(Number(newMonth) - 1); // Restamos 1 porque en JS enero es 0
    updateDisbursementDate(currentDate);
  },
});

// Día (getter + setter)
const day = computed({
  get: () => getCurrentDate()?.getDate() || '',
  set: (newDay) => {
    const currentDate = getCurrentDate() || new Date();
    currentDate.setDate(Number(newDay));
    updateDisbursementDate(currentDate);
  },
});

// Fecha formateada (ej. "29 de Mayo de 2025") (solo lectura)
const formattedDate = computed(() => {
  const date = getCurrentDate();
  if (!date) return '';
  const months = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];
  return `${date.getDate()} de ${months[date.getMonth()]} de ${date.getFullYear()}`;
});

const totalTerm = computed({
  get: () => store.form?.quotations?.totalTerm,
  set: (value) => {
    if (store.form?.quotations) {
      store.form.quotations.totalTerm = value;
    }
  }
});

// Método mejorado para calcular estilos
const getInputStyle = (value, type = 'text') => {
  const length = value?.toString().length || 1;
  let charWidth = 7; // Valor base para texto

  if (type === 'currency') charWidth = 9;
  if (type === 'number') charWidth = 10;
  if (type === 'date') charWidth = 8;

  return {
    width: `${Math.max(30, Math.min(250, length * charWidth))}px`, //300
    'min-width': '30px',
    'max-width': '300px',
    'text-align': type === 'number' ? 'center' : 'left'
  };
};

const handleSubmit = () => {
  store.setPromissoryNoteContent(promissoryNoteContent.value);
  store.saveData();
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  text-indent: 0;
}

#content-to-pdf {
  overflow: visible;
  font-family: Calibri, sans-serif;
  color: #000 !important;
}

.pdf-container.web-container-mode * {
  font-size: 12.5px !important;
}

.page-break {
  page-break-after: always;
  break-after: page;
  height: 0;
  visibility: hidden;
}

.page {
  padding-left: 80px;
  padding-right: 80px;
  background-color: white;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  page-break-inside: avoid;
  margin-bottom: 25px;
  word-spacing: 2px;
  padding-top: 15px;
  padding-bottom: 30px;
}

.page.pdf-mode {
  padding-top: 0;
  padding-bottom: 0;
  box-shadow: none;
  background-color: white;
}

h1 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 12pt;
}

h2 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 10pt;
}

p {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 10pt;
  margin: 0pt;
}

.s1 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: underline;
  font-size: 12pt;
}

.s3 {
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 10pt;
}

.s7,
.s8 {
  color: black;
  font-family: Calibri, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 10pt;
}

table,
tbody {
  vertical-align: top;
  overflow: visible;
}

.download-btn {
  padding: 10px 20px;
  background-color: #42b983;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 20px;
  transition: background-color 0.3s;
}

.download-btn:hover {
  background-color: #369f6e;
}

/* Estilos para inputs en línea */
.underline-input {
  display: inline-block;
  min-width: 30px;
  max-width: 300px;
  transition: width 0.2s ease;
  margin: 0 2px;
  vertical-align: baseline;
  border: 0;
  background: transparent;
  border-bottom: 1px solid #F00;
  padding: 0 0 1px 0;
  font-size: 12px;
  color: #F00;
  height: auto;
  line-height: 1;
}

.underline-input:disabled {
  color: #000;
  border-bottom: 1px solid #000;
  background: transparent;
}

.inline-input,
.inline-input:disabled {
  display: inline-block;
  min-width: 50px;
  /* Ancho mínimo */
  transition: width 0.2s ease;
  /* Transición suave al cambiar el tamaño */
  /*width: 80px !important;*/
  margin: 0 5px;
  vertical-align: middle;
  border: 0;
  background: transparent;
  border-bottom: 1px solid #000;
  border-radius: 0;
  padding: 0 0 2px 0;
  font-family: Calibri, sans-serif;
  font-size: 12px;
  color: #F00;
  border-color: #F00;
  height: auto;
  line-height: normal;
}

.pdf-mode .inline-input {
  line-height: 18px !important;
}

.inline-date-input,
.inline-date-input:disabled {
  display: inline-block;
  width: 150px !important;
  margin: 0 5px;
  vertical-align: middle;
  border: 0;
  background: transparent;
  border-bottom: 1px solid #000;
  border-radius: 0;
  padding: 0 0 2px 0;
  font-family: Calibri, sans-serif;
  font-size: 12px;
  color: #F00;
  height: auto;
  line-height: normal;
}

.pdf-mode .inline-date-input {
  line-height: 18px !important;
}

.form-group.row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.label-form {
  margin-bottom: 0;
  white-space: nowrap;
}

/**Estilo de subrayado */
.ustyle {
  color: #F00;
  text-decoration: underline;
  text-underline-offset: 4px;
  padding-bottom: 2px;
}

.dataInfo {
  color: #F00;
  border-bottom: 1px solid #F00;
}

.style-set-data {
  border-bottom: 1px solid red;
  color: #F00;
}
</style>